import { PersonType } from '../enums/person-type.enum';

export interface AssignorAgents  {
  id: number;
  nomeRepresentante: string;
  email: string;
  tipoPessoa: string;
  cpfCnpj: string;
  numeroTelefone: string;
  assina: boolean;
  assinaTermoCessao: boolean;
  assinaEndosso: boolean;
  emiteDuplicata: boolean;
}
